import {Component, Input, OnInit} from '@angular/core';
import { Booking, PartyInvoice } from '@unleashed/models/booking';

@Component({
  selector: 'ua-call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.scss']
})
export class CallToActionComponent implements OnInit {

  @Input() template?: string;
  @Input() possessive = true;
  @Input() groupText = 'the';
  @Input() booking?: Booking;
  @Input() showTime = false;
  @Input() size: 'normal' | 'large' = 'normal';
  @Input() invoice?: PartyInvoice;

  displayText = '';
  textSize = 'fs-5';

  constructor() { }

  ngOnInit(): void {
    if (!this.template) {
      return;
    }

    this.textSize = this.size === 'normal' ? 'fs-5' : 'fs-3';

    this.displayText = !this.invoice?.isSpecialEvent ?? true
        ? this.template.replace('{0}', this.getGuestDisplay())
        : this.template.replace('{0}', this.invoice?.organizationName ?? '');

  }

  getGuestDisplay(): string {
    // Filter out guests with empty names (the default booking has one guest with firstName: '')
    const guests = this.booking?.guestsOfHonor?.filter(g => g.firstName?.trim()) ?? [];
    if (guests.length === 0) {
      return this.groupText;
    }

    switch (guests.length) {
      case 1:
        return `${guests[0].firstName}${this.possessive ? '\'s' : ''}`;
      case 2:
        this.textSize = this.size === 'normal' ? 'fs-6' : 'fs-4';
        return `${guests[0].firstName} and ${guests[1].firstName}${this.possessive ? '\'s' : ''}`;
      default:
        return this.groupText;
    }
  }
}
